/* lem-partial-variant-fix.js – CRO-60 (2026-10-16): moved unchanged from snippets/lem-partial-variant-fix.liquid (was an inline <script> on every page). */
  (() => {
    if (window.__lemPartialCombinationPatch) return;
    window.__lemPartialCombinationPatch = true;

    /* DEV-440: one request per combination section, shared by the theme's preload and this patch */
    const nativeFetch = window.fetch;
    const sectionRequests = new Map();
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : '';
      if (!/[?&]option_values=[^&]*&section_id=/.test(url) || (init && init.method && init.method !== 'GET')) {
        return nativeFetch.apply(this, arguments);
      }
      let entry = sectionRequests.get(url);
      if (!entry || Date.now() - entry.at > 10000) {
        entry = { at: Date.now(), promise: nativeFetch.call(this, url) };
        sectionRequests.set(url, entry);
        const requested = entry;
        const evict = () => { if (sectionRequests.get(url) === requested) sectionRequests.delete(url); };
        entry.promise.then((response) => { if (!response.ok) evict(); }, evict);
        if (sectionRequests.size > 50) sectionRequests.delete(sectionRequests.keys().next().value);
      }
      const shared = entry.promise.then((response) => response.clone());
      const signal = init && init.signal;
      if (!signal) return shared;
      return new Promise((resolve, reject) => {
        const abort = () => {
          if (sectionRequests.get(url) === entry) sectionRequests.delete(url);
          reject(new DOMException('Aborted', 'AbortError'));
        };
        if (signal.aborted) return abort();
        signal.addEventListener('abort', abort, { once: true });
        shared.then(
          (response) => { signal.removeEventListener('abort', abort); resolve(response); },
          (error) => { signal.removeEventListener('abort', abort); reject(error); }
        );
      });
    };

    const applyPatch = () => {
      const VariantPickerClass = window.customElements.get('variant-picker');
      if (!VariantPickerClass || VariantPickerClass.prototype.__lemPartialPatched) return;
      VariantPickerClass.prototype.__lemPartialPatched = true;

      const originalSelectCombination = VariantPickerClass.prototype.selectCombination;

      const findRenderedPicker = (fragment, formId) => {
        const selector = 'variant-picker[form-id="' + formId + '"]';
        const direct = fragment.querySelector(selector);
        if (direct) return direct;

        for (const template of Array.from(fragment.querySelectorAll('template'))) {
          const nested = template.content.querySelector(selector);
          if (nested) return nested;
        }

        return null;
      };

      const showImageState = (picker, data, variant) => {
        const gallery = picker.closest('.shopify-section--main-product')?.querySelector('product-gallery');
        if (!gallery) return;
        const missing = !!variant && !variant[3] && Object.keys(data.media || {}).length > 0;
        gallery.classList.toggle('lm-variant-image-missing', missing);
        let message = gallery.querySelector('.lm-variant-no-image');
        if (missing && !message) {
          const labels = {
            en: 'Photo unavailable for this colour', lt: 'Šios spalvos nuotraukos dar nėra', fi: 'Tästä väristä ei ole kuvaa',
            de: 'Für diese Farbe ist kein Foto verfügbar', fr: 'Photo indisponible pour cette couleur',
            nl: 'Geen foto beschikbaar voor deze kleur', da: 'Intet foto af denne farve',
            no: 'Bilde er ikke tilgjengelig for denne fargen', sv: 'Bild saknas för den här färgen'
          };
          message = document.createElement('p');
          message.className = 'lm-variant-no-image';
          message.setAttribute('role', 'status');
          message.textContent = labels[document.documentElement.lang.slice(0, 2)] || labels.en;
          gallery.append(message);
        }
        if (message) message.hidden = !missing;
      };

      const previewSelection = (picker, form, optionValues) => {
        if (!picker.closest('.shopify-section--main-product')) return;
        const source = document.querySelector('script[data-lm478="' + picker.getAttribute('form-id') + '"]');
        if (!source) return;
        let data;
        try { data = JSON.parse(source.textContent); } catch (error) { return; }
        if (!data.options) return;
        const selected = data.options.map((values) => optionValues.map((id) => values[id]).find((value) => value !== undefined));
        const matches = data.variants.filter((row) => row[2].every((value, index) => !selected[index] || selected[index] === value));
        const variant = matches.find((row) => row[1]) || matches[0];
        if (!variant) return;
        // DEV-598: chained previews must roll back to the last confirmed URL, never another preview.
        form.__lm598Restore?.(true);
        showImageState(picker, data, variant);
        const previousUrl = window.location.href;
        if (picker.hasAttribute('update-url')) {
          const url = new URL(previousUrl);
          url.searchParams.set('variant', variant[0]);
          window.history.replaceState(window.history.state, '', url);
        }
        picker.dataset.lmPreviewVariant = variant[0];
        picker.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
          const label = picker.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          const value = input.closest('fieldset')?.querySelector('.variant-picker__option-info .h-stack > span:not(.lm-ccount)');
          if (label && value) value.textContent = label.textContent.trim();
        });
        const gallery = picker.closest('.shopify-section--main-product').querySelector('product-gallery');
        const image = gallery && [...gallery.querySelectorAll('.product-gallery__media:not([hidden]) > img')].find((item) => {
          const bounds = item.getBoundingClientRect();
          const parent = gallery.getBoundingClientRect();
          return bounds.right > parent.left && bounds.left < parent.right;
        });
        const src = data.media && data.media[variant[3]];
        const attributes = image && ['src', 'srcset', 'sizes', 'alt'].map((name) => [name, image.getAttribute(name)]);
        if (image && src && variant[3] !== picker.selectedVariant?.featured_media?.id) {
          image.removeAttribute('srcset');
          image.src = src;
          image.alt = selected.filter(Boolean).join(' / ');
        }
        const restore = (failed = false) => {
          if (image) attributes.forEach(([name, value]) => value === null ? image.removeAttribute(name) : image.setAttribute(name, value));
          if (failed) {
            window.history.replaceState(window.history.state, '', previousUrl);
            showImageState(picker, data, data.variants.find((row) => row[0] === picker.selectedVariant?.id));
          }
          delete picker.dataset.lmPreviewVariant;
          form.removeEventListener('product:rerender', onRender, true);
          if (form.__lm598Restore === restore) delete form.__lm598Restore;
        };
        const onRender = () => restore();
        form.__lm598Restore = restore;
        form.addEventListener('product:rerender', onRender, true);
      };

      const syncImageState = () => {
        document.querySelectorAll('.shopify-section--main-product variant-picker').forEach((picker) => {
          const source = document.querySelector('script[data-lm478="' + picker.getAttribute('form-id') + '"]');
          if (!source) return;
          try {
            const data = JSON.parse(source.textContent);
            const current = JSON.parse(picker.querySelector('script[data-variant]').textContent);
            showImageState(picker, data, data.variants.find((row) => row[0] === current.id));
          } catch (error) {}
        });
      };
      document.addEventListener('variant:change', syncImageState);
      syncImageState();

      VariantPickerClass.prototype.selectCombination = async function (args) {
        const formId = this.getAttribute('form-id');
        const form = document.forms[formId];
        const optionValues = (args && args.optionValues) || [];

        if (!form || !optionValues.length || (args && args.productChange)) {
          return originalSelectCombination.call(this, args);
        }

        const optionInputs = Array.from(form.elements).filter(
          (element) => element.matches && element.matches('input[data-option-position]')
        );
        const optionCount = new Set(
          optionInputs.map((element) => element.getAttribute('data-option-position'))
        ).size;

        previewSelection(this, form, optionValues);
        if (optionValues.length >= optionCount) {
          const pending = originalSelectCombination.call(this, args);
          const sequence = form.__b71Seq;
          const result = await pending;
          if (sequence === form.__b71Seq && form.variantFailed) form.__lm598Restore?.(true);
          return result;
        }

        const previousVariant = this.selectedVariant;
        const sequence = (form.__b71Seq = (form.__b71Seq || 0) + 1);
        form.__b71Retry = () => this.selectCombination(args);
        if ('variantPending' in form) form.variantPending = true;
        let requestUrl;

        try {
          let productUrl = window.Shopify.routes.root + 'products/' + this.getAttribute('handle');

          for (const optionValue of optionValues) {
            const matchingInput = optionInputs.find((element) => element.value === optionValue);
            if (matchingInput && matchingInput.dataset.productUrl) {
              productUrl = matchingInput.dataset.productUrl;
              break;
            }
          }

          const sectionParam =
            this.getAttribute('context') === 'quick_buy' ? '' : '&section_id=' + this.getAttribute('section-id');
          const controller = new AbortController();
          const timeout = window.setTimeout(() => controller.abort(), 8000);
          requestUrl = productUrl + '?option_values=' + optionValues.join(',') + sectionParam;
          let response, html;
          try {
            response = await fetch(requestUrl, { signal: controller.signal });
            if (!response.ok) throw new Error(productUrl + ' -> HTTP ' + response.status);
            // The shared fetch has its own response body; keep the deadline active until it is read.
            html = await Promise.race([
              response.text(),
              new Promise((resolve, reject) => {
                if (controller.signal.aborted) return reject(new DOMException('Aborted', 'AbortError'));
                controller.signal.addEventListener('abort', () => reject(new DOMException('Aborted', 'AbortError')), { once: true });
              })
            ]);
          } finally {
            window.clearTimeout(timeout);
          }
          if (sequence !== form.__b71Seq) return;

          const fragment = document.createRange().createContextualFragment(html);
          const renderedPicker = findRenderedPicker(fragment, formId);
          if (!renderedPicker) throw new Error('variant-picker: no picker found in rendered HTML');

          const renderedValues = Array.from(renderedPicker.querySelectorAll('input[data-option-position]'))
            .filter((input) => input.checked)
            .map((input) => input.value);

          // Relaxed check: the server completes the combination for us, so we only require that every
          // value we asked for is part of what came back.
          if (!optionValues.every((value) => renderedValues.includes(value))) {
            throw new Error(
              'variant-picker: asked for [' + optionValues.join(', ') + '], server rendered [' + renderedValues.join(', ') + ']'
            );
          }

          const renderedVariant = JSON.parse(
            (renderedPicker.querySelector('script[data-variant]') || {}).textContent || '{}'
          );

          if (!renderedVariant.id) throw new Error('variant-picker: no variant in rendered HTML');
          if (this.hasAttribute('update-url')) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', renderedVariant.id);
            window.history.replaceState(window.history.state, '', url);
          }
          const sizePosition = this.getAttribute('data-size-position');
          const sizeChosen = this.querySelector('input[data-option-position="' + sizePosition + '"]:checked');
          if (sizePosition && !sizeChosen) {
            renderedPicker.querySelectorAll('input[data-option-position="' + sizePosition + '"]').forEach((input) => input.checked = false);
          }
          form.dispatchEvent(
            new CustomEvent('product:rerender', { detail: { htmlFragment: fragment, productChange: false } })
          );
          form.dispatchEvent(
            new CustomEvent('variant:change', {
              bubbles: true,
              detail: { formId, variant: renderedVariant, previousVariant: previousVariant }
            })
          );

          if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
            window.Shopify.PaymentButton.init();
          }

          if ('variantPending' in form) form.variantPending = false;
        } catch (error) {
          console.warn('[variant-picker partial]', error);
          if (sequence !== form.__b71Seq) return;
          if (requestUrl) sectionRequests.delete(requestUrl);
          form.__lm598Restore?.(true);
          if ('variantPending' in form) form.variantPending = false;
          if ('variantFailed' in form) form.variantFailed = true;
        }
      };
    };

    if (window.customElements.get('variant-picker')) {
      applyPatch();
    } else {
      window.customElements.whenDefined('variant-picker').then(applyPatch);
    }
  })();
